import React, {forwardRef, useImperativeHandle} from 'react';
import TextField from "@mui/material/TextField";

const inputType = "outlined";

let ViewTxnForm = (props, ref) => {
    const [id, setId] = React.useState("");
    const [type, setType] = React.useState("");
    const [client, setClient] = React.useState({});
    const [agent, setAgent] = React.useState({});
    const [reference, setReference] = React.useState("");
    const [responseData, setResponseData] = React.useState("");
    const [status, setStatus] = React.useState("");
    const [message, setMessage] = React.useState("");
    const [amount, setAmount] = React.useState("");
    const [exchangeAmount, setExchangeAmount] = React.useState(0);
    const [createdAt, setCreatedAt] = React.useState("");
    const [updatedAt, setUpdatedAt] = React.useState("");

    useImperativeHandle(ref, () => ({
        getValues: () => {
            return ({id, client, agent, status, type, amount, reference});
        },
        reinit: () => {
            setId("");
            setType("");
            setClient({});
            setAgent({});
            setReference("");
            setResponseData("");
            setStatus("");
            setMessage("");
            setAmount("");
            setExchangeAmount(0);
            setUpdatedAt("");
            setCreatedAt("");
        }
    }));

    React.useEffect(() => {
        let { data } = props;
        if(data) {
            setId(data.id);
            setType(data.type);
            setClient(data.client);
            setAgent(data.agent);
            setReference(data.request_data);
            setResponseData(data.response_data);
            setStatus(data.status);
            setMessage(data.message ?? '');
            setAmount(`${data.amount} ${data?.currency}`);
            setExchangeAmount(`${data.transaction_exchange_amount ?? 0} ${data?.currency} /${data.transaction_exchange_currency ?? ''}`);
            setCreatedAt(data.created_at);
            setUpdatedAt(data.updated_at);
        }
    }, [props.data]);

    return (
        <div>
            <div className="text-left">
                <div className="col-span-2">
                    <h3 className="font-bold">Transaction - {id}</h3>
                    <hr></hr>
                </div>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Type"}
                    value={type.split("_").join(" ")}
                    readOnly={true}
                    variant={inputType}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Amount"}
                    value={amount}
                    readOnly={true}
                    variant={inputType}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Exchange Amount"}
                    value={exchangeAmount}
                    readOnly={true}
                    variant={inputType}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Status"}
                    value={status}
                    readOnly={true}
                    variant={inputType}
                    className="__form-input"/>
            </div> 
            
            <div className="__line __fist">
                <TextField
                    label={"Message"}
                    value={message}
                    readOnly={true}
                    variant={inputType}
                    className="__form-input"/>
            </div>
            
            <div className="__line __fist">
                <TextField
                    label={"Client"}
                    value={`${client?.first_name || ''} - ${client?.username || ''}`}
                    variant={inputType}
                    readOnly={true}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Agent"}
                    value={`${agent?.first_name || ''} - ${agent?.username || ''}`}
                    variant={inputType}
                    readOnly={true}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Reference"}
                    value={reference}
                    variant={inputType}
                    readOnly={true}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Response Data"}
                    value={responseData}
                    variant={inputType}
                    readOnly={true}
                    className="__form-input"/>
            </div>
            <div className="text-left">
                <div className="col-span-2">
                    <h2 className="font-bold">Dates</h2>
                    <hr></hr>
                </div>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Created"}
                    value={`${new Date(createdAt || 0).toDateString()}, ${new Date(createdAt || 0).toTimeString()}`}
                    variant={inputType}
                    readOnly={true}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <TextField
                    label={"Updated"}
                    value={`${new Date(updatedAt || 0).toDateString()}, ${new Date(updatedAt || 0).toTimeString()}`}
                    variant={inputType}
                    readOnly={true}
                    className="__form-input"/>
            </div>
        </div>
    );
};

export default forwardRef(ViewTxnForm);